import { z } from 'zod';

export const llmSchema = z.object({
  configuration: z.object({
    default_llm_service: z.string({ message: 'LLM is required' }),
    default_stt_service: z.string({ message: 'STT is required' }),
    default_tts_service: z.string({ message: 'TTS is required' })
  })
});

export const pricingSchema = z.object({
  configuration: z.object({
    stripe_secret_key: z.string({ message: 'Secret Key is required' }),
    stripe_publishable_key: z.string({ message: 'Publishable Key is required' }),
    stripe_webhook_secret: z.string({ message: 'Webhook Secret is required' }),
    per_min_cost: z.string({ message: 'Cost is required' }),
    billing_enabled: z.boolean().default(false)
  })
});

export const smtpSchema = z.object({
  configuration: z.object({
    smtp_username: z.string({ message: 'SMTP Username is required' }),
    smtp_password: z.string({ message: 'SMTP Password is required' }),
    smtp_address: z.string({ message: 'SMTP Address is required' }),
    smtp_domain: z.string({ message: 'SMTP Domain is required' }),
    smtp_port: z.number({ message: 'SMTP Port is required' }),
    smtp_from_name: z.string({ message: 'SMTP From Name is required' }),
    smtp_from: z
      .string({ message: 'SMTP From is required' })
      .email({ message: 'SMTP From must be a valid email address' })
  })
});

export const twilioSchema = z.object({
  configuration: z.object({
    twilio_account_sid: z.string({ message: 'Twilio Account SID is required' }),
    twilio_auth_token: z.string({ message: 'Twilio Auth Token is required' }),
    twilio_trunk_sid: z.string({ message: 'Twilio Trunk SID is required' }),
    termination_sip_uri: z.string({ message: 'Termination SIP URI is required' }),
    termination_username: z.string({ message: 'Termination Username is required' }),
    termination_password: z.string({ message: 'Termination Password is required' })
  })
});
